import axios from 'axios';

export const getStageRequest = async () => {
  const settingsResp = await axios.get(`/api/settings/`);
  return settingsResp.data.currentStage;
};
